import { createRouter, createWebHistory } from 'vue-router'

const routes = [ 
    {
        path: '/',
        component: () => import('../views/index1'),
    },
]

const router = createRouter({
    // history: createWebHistory('/appspery/vue/'),
    history: createWebHistory('/'),
    routes
})

export default router;